import React, { useState } from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography, IconButton, Tooltip } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../../assets/images/neo_favicon.png';

// Custom SVG Icons
const OverviewIcon = ({ isActive }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <rect x="0" y="0" width="32" height="32" rx="12" ry="12" fill={isActive ? "#36C5F0" : "rgba(42, 51, 89, 0.8)"} />
    <g clipPath="url(#clip0_130_644)" transform="translate(8, 8)">
      <path 
        d="M8.16289 3.46748C8.11927 3.42575 8.06124 3.40247 8.00088 3.40247C7.94052 3.40247 7.88248 3.42575 7.83887 3.46748L2.44531 8.61992C2.42241 8.64183 2.40418 8.66816 2.39175 8.69731C2.37931 8.72647 2.37291 8.75785 2.37295 8.78955L2.37207 13.6253C2.37207 13.8739 2.47084 14.1124 2.64666 14.2882C2.82247 14.464 3.06093 14.5628 3.30957 14.5628H6.125C6.24932 14.5628 6.36855 14.5134 6.45645 14.4255C6.54436 14.3376 6.59375 14.2184 6.59375 14.094V10.1097C6.59375 10.0475 6.61844 9.98789 6.6624 9.94393C6.70635 9.89998 6.76596 9.87529 6.82812 9.87529H9.17187C9.23403 9.87529 9.29365 9.89998 9.3376 9.94393C9.38155 9.98789 9.40625 10.0475 9.40625 10.1097V14.094C9.40625 14.2184 9.45563 14.3376 9.54354 14.4255C9.63145 14.5134 9.75068 14.5628 9.875 14.5628H12.6893C12.9379 14.5628 13.1764 14.464 13.3522 14.2882C13.528 14.1124 13.6268 13.8739 13.6268 13.6253V8.78955C13.6268 8.75785 13.6204 8.72647 13.608 8.69731C13.5955 8.66816 13.5773 8.64183 13.5544 8.61992L8.16289 3.46748Z" 
        fill={isActive ? "white" : "#36C5F0"}
      />
      <path 
        d="M14.8821 7.65369L12.6907 5.5572V2.37585C12.6907 2.25153 12.6413 2.13231 12.5534 2.0444C12.4655 1.95649 12.3463 1.9071 12.222 1.9071H10.8157C10.6914 1.9071 10.5722 1.95649 10.4843 2.0444C10.3964 2.13231 10.347 2.25153 10.347 2.37585V3.31335L8.65011 1.69089C8.49132 1.53035 8.25518 1.43835 8.00001 1.43835C7.74571 1.43835 7.51016 1.53035 7.35138 1.69119L1.11993 7.6531C0.937706 7.82888 0.914855 8.11804 1.08068 8.30847C1.12232 8.35654 1.1733 8.39563 1.23053 8.42337C1.28776 8.4511 1.35003 8.46691 1.41356 8.46981C1.47709 8.47272 1.54054 8.46266 1.60006 8.44026C1.65958 8.41787 1.71392 8.38359 1.75978 8.33953L7.83888 2.53054C7.88249 2.48882 7.94053 2.46553 8.00089 2.46553C8.06125 2.46553 8.11928 2.48882 8.1629 2.53054L14.2426 8.33953C14.3321 8.42541 14.4521 8.47228 14.5762 8.46986C14.7002 8.46745 14.8183 8.41594 14.9044 8.32663C15.0843 8.14031 15.0693 7.83269 14.8821 7.65369Z" 
        fill={isActive ? "white" : "#36C5F0"}
      />
    </g>
    <defs>
      <clipPath id="clip0_130_644">
        <rect width="15" height="15" fill="white" transform="translate(0.5 0.5)"/>
      </clipPath>
    </defs>
  </svg>
);

const EvidenceIcon = ({ isActive }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <rect x="0" y="0" width="32" height="32" rx="12" ry="12" fill={isActive ? "#36C5F0" : "rgba(42, 51, 89, 0.8)"} />
    <g clipPath="url(#clip0_130_641)" transform="translate(8, 8)">
      <path 
        d="M3.54687 15.0316H2.60937C2.42289 15.0316 2.24405 14.9575 2.11219 14.8257C1.98033 14.6938 1.90625 14.515 1.90625 14.3285V10.1097C1.90625 9.92326 1.98033 9.74442 2.11219 9.61256C2.24405 9.4807 2.42289 9.40662 2.60937 9.40662H3.54687C3.73335 9.40662 3.9122 9.4807 4.04406 9.61256C4.17592 9.74442 4.25 9.92326 4.25 10.1097V14.3285C4.25 14.515 4.17592 14.6938 4.04406 14.8257C3.9122 14.9575 3.73335 15.0316 3.54687 15.0316Z" 
        fill={isActive ? "white" : "#36C5F0"}
      />
      <path 
        d="M10.1094 15.0308H9.17187C8.98539 15.0308 8.80655 14.9567 8.67469 14.8249C8.54283 14.693 8.46875 14.5142 8.46875 14.3277V7.29645C8.46875 7.10997 8.54283 6.93112 8.67469 6.79926C8.80655 6.6674 8.98539 6.59332 9.17187 6.59332H10.1094C10.2959 6.59332 10.4747 6.6674 10.6066 6.79926C10.7384 6.93112 10.8125 7.10997 10.8125 7.29645V14.3277C10.8125 14.5142 10.7384 14.693 10.6066 14.8249C10.4747 14.9567 10.2959 15.0308 10.1094 15.0308Z" 
        fill={isActive ? "white" : "#36C5F0"}
      />
      <path 
        d="M13.3906 15.0312H12.4531C12.2666 15.0312 12.0878 14.9571 11.9559 14.8252C11.8241 14.6934 11.75 14.5145 11.75 14.3281V4.01556C11.75 3.82908 11.8241 3.65024 11.9559 3.51838C12.0878 3.38652 12.2666 3.31244 12.4531 3.31244H13.3906C13.5771 3.31244 13.7559 3.38652 13.8878 3.51838C14.0197 3.65024 14.0937 3.82908 14.0937 4.01556V14.3281C14.0937 14.5145 14.0197 14.6934 13.8878 14.8252C13.7559 14.9571 13.5771 15.0312 13.3906 15.0312Z" 
        fill={isActive ? "white" : "#36C5F0"}
      />
      <path 
        d="M6.82812 15.031H5.89062C5.70414 15.031 5.5253 14.9569 5.39344 14.8251C5.26158 14.6932 5.1875 14.5144 5.1875 14.3279V1.67163C5.1875 1.48515 5.26158 1.30631 5.39344 1.17445C5.5253 1.04258 5.70414 0.968506 5.89062 0.968506H6.82812C7.0146 0.968506 7.19345 1.04258 7.32531 1.17445C7.45717 1.30631 7.53125 1.48515 7.53125 1.67163V14.3279C7.53125 14.5144 7.45717 14.6932 7.32531 14.8251C7.19345 14.9569 7.0146 15.031 6.82812 15.031Z" 
        fill={isActive ? "white" : "#36C5F0"}
      />
    </g>
    <defs>
      <clipPath id="clip0_130_641">
        <rect width="15" height="15" fill="white" transform="translate(0.5 0.5)"/>
      </clipPath>
    </defs>
  </svg>
);

const menuItems = [
  { id: 'storeoverview', title: 'Overview', url: '/main/stores/storeinsight', icon: OverviewIcon },
  { id: 'evidences', title: 'Evidence', url: '/main/stores/evidence', icon: EvidenceIcon }
];

const SideBarContent = ({ isExpanded: propIsExpanded = false, isMobile, onClose: propOnClose }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  
  // Use the prop value directly instead of local state
  const isExpanded = propIsExpanded;
  const [isHovered, setIsHovered] = useState(false);

  const accessToken = localStorage.getItem('accessToken');

  // Handle sidebar toggle - call parent's toggle function
  const handleToggleSidebar = () => {
    if (propOnClose) {
      propOnClose();
    }
  };

  // Handle close from parent component
  const handleClose = () => {
    if (propOnClose) {
      propOnClose();
    }
  };

  const handleNavigation = (path) => {
    navigate(path);
    if (isMobile && handleClose) handleClose();
  };

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userData');
    localStorage.removeItem('savedUsername');
    navigate('/');
    if (isMobile && handleClose) handleClose();
  };

  // const handleProfileNavigation = () => {
  //   navigate('/main/profile');
  //   if (isMobile && handleClose) handleClose();
  // };

  const isPathActive = (path) => pathname.includes(path);

  const accountItems = accessToken
    ? [
        // { id: 'profile', title: 'Profile', url: '/main/profile', icon: PersonIcon, action: handleProfileNavigation },
        { id: 'signout', title: 'Sign Out', url: '#', icon: LogoutIcon, action: handleLogout }
      ]
    : [
        { id: 'profile', title: 'Profile', url: '/profile', icon: PersonIcon },
        { id: 'signup', title: 'Sign Up', url: '/signup', icon: PersonAddIcon }
      ];

  const expandedWidth = 360;
  const collapsedWidth = 72;

  // Use local state for sidebar control
  const computedWidth = isMobile ? (isExpanded ? expandedWidth : 0) : isExpanded ? expandedWidth : collapsedWidth;

  const styles = {
    container: {
      position: 'fixed',
      top: 0,
      left: 0,
      height: '100vh',
      width: computedWidth,
      background: 'linear-gradient(110deg, rgba(6,11,38,0.94) 74.67%, rgba(6,11,40,0.31) 100%)',
      borderRight: '1px solid rgba(255, 255, 255, 0.08)',
      backdropFilter: 'blur(60px)',
      transition: 'width 0.28s ease',
      zIndex: 140,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    },
    overlay: {
      position: 'fixed',
      inset: 0,
      left: 0,
      right: 0,
      bottom: 0,
      top: 0,

      background: 'rgba(0,0,0,0.35)',
      backdropFilter: 'blur(1px)',
      WebkitBackdropFilter: 'blur(1px)',
      zIndex: 139,
      display: isMobile && isExpanded ? 'block' : 'none'
    },
    headerSection: {
      padding: isExpanded ? '16px 16px' : '16px 12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: isExpanded ? 'space-between' : 'center',
      borderBottom: '1px solid rgba(255,255,255,0.06)',
      minHeight: 74,
      position: 'relative'
    },
    logo: {
      width: 36,
      height: 30,
      objectFit: 'contain',
      cursor: 'pointer',
      filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.4))',
      flexShrink: 0,
      opacity: isExpanded ? 1 : (isHovered ? 0 : 1),
      transition: 'opacity 0.2s ease'
    },
    brandText: {
      textAlign: 'left',
      fontFamily: 'Plus Jakarta Sans',
      fontSize: '20px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '100%',
      letterSpacing: '4.8px',
      background: 'linear-gradient(177deg, #FFF 27.68%, #224E70 127.11%)',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      marginLeft: 5,
      opacity: isExpanded ? 1 : 0,
      transition: 'opacity 0.2s ease',
      whiteSpace: 'nowrap'
    },
    closeButton: {
      color: 'white',
      display: isExpanded ? 'inline-flex' : 'none',
      '&:hover': { backgroundColor: 'rgba(255,255,255,0.08)' }
    },
    hoverMenuButton: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      color: 'white',
      backgroundColor: 'rgba(255,255,255,0.1)',
      display: !isExpanded && isHovered ? 'flex' : 'none',
      '&:hover': { 
        backgroundColor: 'rgba(255,255,255,0.2)',
        transform: 'translate(-50%, -50%) scale(1.1)'
      },
      transition: 'all 0.2s ease',
      zIndex: 10
    },
    sectionTitle: {
      color: 'rgba(255,255,255,0.55)',
      fontSize: 12,
      fontWeight: 500,
      textTransform: 'uppercase',
      padding: isExpanded ? '14px 16px 8px' : 0,
      opacity: isExpanded ? 1 : 0,
      transition: 'opacity 0.18s ease'
    },
    list: {
      padding: isExpanded ? '0 10px 12px' : '8px 6px',
      display: 'flex',
      flexDirection: 'column',
      gap: 2
    },
    listItemBase: {
      borderRadius: 4,
      padding: isExpanded ? '10px 12px' : '10px 8px',
      color: 'rgba(255,255,255,0.75)',
      cursor: 'pointer',
      transition: 'all 0.18s ease',
      justifyContent: isExpanded ? 'flex-start' : 'center',
      minHeight: 44,
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: 'rgba(255,255,255,0.06)',
        color: '#fff',
        borderRadius: 4
      }
    },
    listItemActive: {
      position: 'relative',
      borderRadius: '4px',
      background: 'linear-gradient(176deg, #1B2242 32.43%, #060C28 99.85%)',
      boxShadow: '0 3.5px 5.5px 0 rgba(0, 0, 0, 0.02)',
      color: '#36C5F0',
      '&:hover': {
        background: 'linear-gradient(176deg, #1B2242 32.43%, #060C28 99.85%)',
        color: '#36C5F0'
      },
      '& .MuiListItemIcon-root': { 
        color: 'white' 
      }
    },
    icon: {
      minWidth: isExpanded ? 24 : 'auto',
      marginRight: isExpanded ? 12 : 0,
      display: 'flex',
      justifyContent: 'center',
      color: '#36C5F0'
    },
    listItemText: {
      opacity: isExpanded ? 1 : 0,
      transition: 'opacity 0.15s ease',
      fontFamily: 'Plus Jakarta Sans, sans-serif',
      '& .MuiListItemText-primary': {
        fontSize: 14,
        fontWeight: 500,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        fontFamily: 'Plus Jakarta Sans, sans-serif'
      }
    }
  };

  const renderNavItem = (item) => {
    const isActive = isPathActive(item.url);
    const Icon = item.icon;
    
    // Create a simple icon version for collapsed state
    const SimpleIcon = ({ isActive }) => (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <rect x="0" y="0" width="32" height="32" rx="12" ry="12" fill={isActive ? "#36C5F0" : "rgba(42, 51, 89, 0.8)"} />
        <g clipPath={item.id === 'storeoverview' ? "url(#clip0_130_644)" : "url(#clip0_130_641)"} transform="translate(8, 8)">
          {item.id === 'storeoverview' ? (
            <>
              <path 
                d="M8.16289 3.46748C8.11927 3.42575 8.06124 3.40247 8.00088 3.40247C7.94052 3.40247 7.88248 3.42575 7.83887 3.46748L2.44531 8.61992C2.42241 8.64183 2.40418 8.66816 2.39175 8.69731C2.37931 8.72647 2.37291 8.75785 2.37295 8.78955L2.37207 13.6253C2.37207 13.8739 2.47084 14.1124 2.64666 14.2882C2.82247 14.464 3.06093 14.5628 3.30957 14.5628H6.125C6.24932 14.5628 6.36855 14.5134 6.45645 14.4255C6.54436 14.3376 6.59375 14.2184 6.59375 14.094V10.1097C6.59375 10.0475 6.61844 9.98789 6.6624 9.94393C6.70635 9.89998 6.76596 9.87529 6.82812 9.87529H9.17187C9.23403 9.87529 9.29365 9.89998 9.3376 9.94393C9.38155 9.98789 9.40625 10.0475 9.40625 10.1097V14.094C9.40625 14.2184 9.45563 14.3376 9.54354 14.4255C9.63145 14.5134 9.75068 14.5628 9.875 14.5628H12.6893C12.9379 14.5628 13.1764 14.464 13.3522 14.2882C13.528 14.1124 13.6268 13.8739 13.6268 13.6253V8.78955C13.6268 8.75785 13.6204 8.72647 13.608 8.69731C13.5955 8.66816 13.5773 8.64183 13.5544 8.61992L8.16289 3.46748Z" 
                fill={isActive ? "white" : "#36C5F0"}
              />
              <path 
                d="M14.8821 7.65369L12.6907 5.5572V2.37585C12.6907 2.25153 12.6413 2.13231 12.5534 2.0444C12.4655 1.95649 12.3463 1.9071 12.222 1.9071H10.8157C10.6914 1.9071 10.5722 1.95649 10.4843 2.0444C10.3964 2.13231 10.347 2.25153 10.347 2.37585V3.31335L8.65011 1.69089C8.49132 1.53035 8.25518 1.43835 8.00001 1.43835C7.74571 1.43835 7.51016 1.53035 7.35138 1.69119L1.11993 7.6531C0.937706 7.82888 0.914855 8.11804 1.08068 8.30847C1.12232 8.35654 1.1733 8.39563 1.23053 8.42337C1.28776 8.4511 1.35003 8.46691 1.41356 8.46981C1.47709 8.47272 1.54054 8.46266 1.60006 8.44026C1.65958 8.41787 1.71392 8.38359 1.75978 8.33953L7.83888 2.53054C7.88249 2.48882 7.94053 2.46553 8.00089 2.46553C8.06125 2.46553 8.11928 2.48882 8.1629 2.53054L14.2426 8.33953C14.3321 8.42541 14.4521 8.47228 14.5762 8.46986C14.7002 8.46745 14.8183 8.41594 14.9044 8.32663C15.0843 8.14031 15.0693 7.83269 14.8821 7.65369Z" 
                fill={isActive ? "white" : "#36C5F0"}
              />
            </>
          ) : (
            <>
              <path 
                d="M3.54687 15.0316H2.60937C2.42289 15.0316 2.24405 14.9575 2.11219 14.8257C1.98033 14.6938 1.90625 14.515 1.90625 14.3285V10.1097C1.90625 9.92326 1.98033 9.74442 2.11219 9.61256C2.24405 9.4807 2.42289 9.40662 2.60937 9.40662H3.54687C3.73335 9.40662 3.9122 9.4807 4.04406 9.61256C4.17592 9.74442 4.25 9.92326 4.25 10.1097V14.3285C4.25 14.515 4.17592 14.6938 4.04406 14.8257C3.9122 14.9575 3.73335 15.0316 3.54687 15.0316Z" 
                fill={isActive ? "white" : "#36C5F0"}
              />
              <path 
                d="M10.1094 15.0308H9.17187C8.98539 15.0308 8.80655 14.9567 8.67469 14.8249C8.54283 14.693 8.46875 14.5142 8.46875 14.3277V7.29645C8.46875 7.10997 8.54283 6.93112 8.67469 6.79926C8.80655 6.6674 8.98539 6.59332 9.17187 6.59332H10.1094C10.2959 6.59332 10.4747 6.6674 10.6066 6.79926C10.7384 6.93112 10.8125 7.10997 10.8125 7.29645V14.3277C10.8125 14.5142 10.7384 14.693 10.6066 14.8249C10.4747 14.9567 10.2959 15.0308 10.1094 15.0308Z" 
                fill={isActive ? "white" : "#36C5F0"}
              />
              <path 
                d="M13.3906 15.0312H12.4531C12.2666 15.0312 12.0878 14.9571 11.9559 14.8252C11.8241 14.6934 11.75 14.5145 11.75 14.3281V4.01556C11.75 3.82908 11.8241 3.65024 11.9559 3.51838C12.0878 3.38652 12.2666 3.31244 12.4531 3.31244H13.3906C13.5771 3.31244 13.7559 3.38652 13.8878 3.51838C14.0197 3.65024 14.0937 3.82908 14.0937 4.01556V14.3281C14.0937 14.5145 14.0197 14.6934 13.8878 14.8252C13.7559 14.9571 13.5771 15.0312 13.3906 15.0312Z" 
                fill={isActive ? "white" : "#36C5F0"}
              />
              <path 
                d="M6.82812 15.031H5.89062C5.70414 15.031 5.5253 14.9569 5.39344 14.8251C5.26158 14.6932 5.1875 14.5144 5.1875 14.3279V1.67163C5.1875 1.48515 5.26158 1.30631 5.39344 1.17445C5.5253 1.04258 5.70414 0.968506 5.89062 0.968506H6.82812C7.0146 0.968506 7.19345 1.04258 7.32531 1.17445C7.45717 1.30631 7.53125 1.48515 7.53125 1.67163V14.3279C7.53125 14.5144 7.45717 14.6932 7.32531 14.8251C7.19345 14.9569 7.0146 15.031 6.82812 15.031Z" 
                fill={isActive ? "white" : "#36C5F0"}
              />
            </>
          )}
        </g>
        <defs>
          <clipPath id={item.id === 'storeoverview' ? "clip0_130_644" : "clip0_130_641"}>
            <rect width="15" height="15" fill="white" transform="translate(0.5 0.5)"/>
          </clipPath>
        </defs>
      </svg>
    );

    const listItemStyles = {
      ...styles.listItemBase,
      ...(isActive && isExpanded && {
        borderRadius: '4px',
        background: 'linear-gradient(176deg, #1B2242 32.43%, #060C28 99.85%)',
        boxShadow: '0 3.5px 5.5px 0 rgba(0, 0, 0, 0.02)',
        color: 'white',
        '&:hover': {
          background: 'linear-gradient(176deg, #1B2242 32.43%, #060C28 99.85%)',
          color: 'white'
        }
      })
    };

    const iconStyles = {
      ...styles.icon,
      color: isActive && isExpanded ? 'white' : '#36C5F0'
    };

    const textStyles = {
      ...styles.listItemText,
      ...(isActive && isExpanded && {
        '& .MuiListItemText-primary': {
          ...styles.listItemText['& .MuiListItemText-primary'],
          color: 'white',
          fontWeight: 600
        }
      })
    };

    const node = (
      <ListItem
        key={item.id}
        onClick={() => handleNavigation(item.url)}
        sx={listItemStyles}
      >
        <ListItemIcon sx={iconStyles}>
          {isExpanded ? (
            <Icon isActive={isActive} />
          ) : (
            <SimpleIcon isActive={isActive} />
          )}
        </ListItemIcon>
        {isExpanded && <ListItemText primary={item.title} sx={textStyles} />}
      </ListItem>
    );
    return isExpanded ? (
      node
    ) : (
      <Tooltip key={item.id} title={item.title} placement="right">
        <Box>{node}</Box>
      </Tooltip>
    );
  };

  // // Custom Account Icons with background styling
  // const CustomProfileIcon = ({ isActive }) => (
  //   <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
  //     <rect x="0" y="0" width="32" height="32" rx="12" ry="12" fill={isActive ? "#36C5F0" : "rgba(42, 51, 89, 0.8)"} />
  //     <g transform="translate(10, 10) scale(0.75)">
  //       <path 
  //         d="M8 8C9.06087 8 10.0783 7.57857 10.8284 6.82843C11.5786 6.07828 12 5.06087 12 4C12 2.93913 11.5786 1.92172 10.8284 1.17157C10.0783 0.421427 9.06087 0 8 0C6.93913 0 5.92172 0.421427 5.17157 1.17157C4.42143 1.92172 4 2.93913 4 4C4 5.06087 4.42143 6.07828 5.17157 6.82843C5.92172 7.57857 6.93913 8 8 8ZM8 10C3.58 10 0 11.79 0 14V16H16V14C16 11.79 12.42 10 8 10Z"
  //         fill={isActive ? "white" : "#36C5F0"}
  //       />
  //     </g>
  //   </svg>
  // );

  const CustomSignOutIcon = ({ isActive }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <rect x="0" y="0" width="32" height="32" rx="12" ry="12" fill={isActive ? "#36C5F0" : "rgba(42, 51, 89, 0.8)"} />
      <g transform="translate(8, 8) scale(0.65)">
        <path 
          d="M17 16L21 12M21 12L17 8M21 12L7 12M13 16V17C13 18.6569 11.6569 20 10 20H6C4.34315 20 3 18.6569 3 17V7C3 5.34315 4.34315 4 6 4H10C11.6569 4 13 5.34315 13 7V8" 
          stroke={isActive ? "white" : "#36C5F0"} 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth="2"
        />
      </g>
    </svg>
  );

  const CustomSignUpIcon = ({ isActive }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <rect x="0" y="0" width="32" height="32" rx="12" ry="12" fill={isActive ? "#36C5F0" : "rgba(42, 51, 89, 0.8)"} />
      <g transform="translate(8, 8)">
        <path 
          d="M6 8C7.06087 8 8.07828 7.57857 8.82843 6.82843C9.57857 6.07828 10 5.06087 10 4C10 2.93913 9.57857 1.92172 8.82843 1.17157C8.07828 0.421427 7.06087 0 6 0C4.93913 0 3.92172 0.421427 3.17157 1.17157C2.42143 1.92172 2 2.93913 2 4C2 5.06087 2.42143 6.07828 3.17157 6.82843C3.92172 7.57857 4.93913 8 6 8ZM6 10C2.69 10 0 11.79 0 14V16H12V14C12 11.79 9.31 10 6 10ZM14 7V4H13V7H10V8H13V11H14V8H17V7H14Z"
          fill={isActive ? "white" : "#36C5F0"}
        />
      </g>
    </svg>
  );

  const renderAccountItem = (item) => {
    const isActive = item.url !== '#' && isPathActive(item.url);
    let IconComponent;
    
    // Map the original icons to our custom wrapped versions
    if (item.icon === PersonIcon) {
      IconComponent = CustomProfileIcon;
    } else if (item.icon === LogoutIcon) {
      IconComponent = CustomSignOutIcon;
    } else if (item.icon === PersonAddIcon) {
      IconComponent = CustomSignUpIcon;
    } else {
      IconComponent = item.icon;
    }

    const listItemStyles = {
      ...styles.listItemBase,
      ...(isActive && isExpanded && {
        borderRadius: '4px',
        background: 'linear-gradient(176deg, #1B2242 32.43%, #060C28 99.85%)',
        boxShadow: '0 3.5px 5.5px 0 rgba(0, 0, 0, 0.02)',
        color: 'white',
        '&:hover': {
          background: 'linear-gradient(176deg, #1B2242 32.43%, #060C28 99.85%)',
          color: 'white'
        }
      })
    };

    const iconStyles = {
      ...styles.icon,
      color: isActive && isExpanded ? 'white' : '#36C5F0'
    };

    const textStyles = {
      ...styles.listItemText,
      ...(isActive && isExpanded && {
        '& .MuiListItemText-primary': {
          ...styles.listItemText['& .MuiListItemText-primary'],
          color: 'white',
          fontWeight: 600
        }
      })
    };
    
    const node = (
      <ListItem
        key={item.id}
        onClick={item.action || (() => handleNavigation(item.url))}
        sx={listItemStyles}
      >
        <ListItemIcon sx={iconStyles}>
          <IconComponent isActive={isActive} />
        </ListItemIcon>
        {isExpanded && <ListItemText primary={item.title} sx={textStyles} />}
      </ListItem>
    );
    return isExpanded ? (
      node
    ) : (
      <Tooltip key={item.id} title={item.title} placement="right">
        <Box>{node}</Box>
      </Tooltip>
    );
  };

  return (
    <>
      {/* Mobile overlay */}
      <Box sx={styles.overlay} onClick={handleClose} />

      <Box 
        sx={styles.container}
        onMouseEnter={() => !isExpanded && setIsHovered(true)}
        onMouseLeave={() => !isExpanded && setIsHovered(false)}
      >
        {/* Top / logo row */}
        <Box sx={styles.headerSection}>
          <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', width: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: isExpanded ? 'flex-start' : 'center' }}>
              <img 
                src={logo} 
                alt="logo" 
                style={{...styles.logo, marginLeft: isExpanded ? '8px' : '0px'}}
                onClick={() => handleNavigation('/main/stores/storeinsight')} 
              />
              {isExpanded && <Typography sx={styles.brandText}>SENTINEL AI</Typography>}
            </Box>
            {isExpanded && (
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: 1 }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="234" height="1" viewBox="0 0 234 1" fill="none">
                  <path 
                    d="M0 0.5H233.25" 
                    stroke="url(#paint0_linear_69_990)"
                    strokeWidth="1px"
                  />
                  <defs>
                    <linearGradient id="paint0_linear_69_990" x1="0" y1="0.5" x2="231" y2="0.5" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#E0E1E2" stopOpacity="0"/>
                      <stop offset="0.5" stopColor="#E0E1E2"/>
                      <stop offset="1" stopColor="#E0E1E2" stopOpacity="0.15625"/>
                    </linearGradient>
                  </defs>
                </svg>
              </Box>
            )}
          </Box>

          {/* Close button when expanded */}
          <IconButton onClick={handleClose} sx={styles.closeButton}>
            <CloseIcon sx={{ fontSize: 22 }} />
          </IconButton>

          {/* Hover menu button that appears over logo when collapsed */}
          <IconButton 
            onClick={handleToggleSidebar} 
            sx={styles.hoverMenuButton}
          >
            <MenuIcon sx={{ fontSize: 22 }} />
          </IconButton>
        </Box>

        {/* Content */}
        <Box sx={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
          {/* <Typography sx={styles.sectionTitle}>Dashboard Screen</Typography> */}
          <List sx={styles.list}>{menuItems.map(renderNavItem)}</List>

          {/* <Typography sx={styles.sectionTitle}>Account Pages</Typography> */}
          <List sx={styles.list}>{accountItems.map(renderAccountItem)}</List>
        </Box>
      </Box>
    </>
  );
};

export default SideBarContent;
